export const SET_GAME_DATA = "SET_GAME_DATA";
